module.exports = __webpack_public_path__ + "img/customer_1.9fe1e741.png";